import styled from "styled-components";

export const StyledLoadingError = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: ${(props) => props.$marginTop || "0"};
  min-height: ${(props) => props.$minHeight || "auto"};
  padding: ${(props) => props.$padding || "0 20px"};
  text-align: center;
  width: 100%;

  .loading-error-icon {
    font-size: 48px;
  }

  .loading-error-title {
    color: #333;
    font-size: 24px;
    font-weight: 600;
    margin: 24px 0 8px;
  }

  .loading-error-message {
    color: #3b444d;
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    max-width: 320px;
  }

  .loading-error-action {
    background: ${(props) => props.$primaryColor};
    border: 0;
    border-radius: 6px;
    color: ${(props) => props.$secondaryColor};
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    margin-top: 24px;
    padding: 12px 24px;
  }
`;
